import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import AnalyticsCommonHeader from "AnalyticscommonAnalyticscommon";
import {
  DASHBOARD_USERS,
  DASHBOARD_TOTAL_USERS,
  DASHBOARD_DEVICE,
  DASHBOARD_OUTREACH,
  DASHBOARD_NETWORKING,
  DASHBOARD_SESSIONS,
} from "DashboardActions";
import { screenHeightLeftFromTop } from "Constants";
import DashboardMenuIcon from "./dashboard-menu-icon";
import UserListModal from "./analytics-user-list";
import TableContentTopSearch from "./table-content-most-search";
import DashboardUser from "./user/dashboard-user";
import DashboardDevice from "./device/dashboard-device";
import DashboardOutreach from "./outreach/index";
import DashboardNetworking from "./networking/dashboard-networking";
import DashboardSession from "./session/dashboard-session";
import DashboardEngmntBarChart from "./dashboard-engmnt-barchart";
import LocaleStrings from "Languages";

// import "AwesomeLoaderCss";

import {
  fetchHits,
  fetchTotalNoHits,
  fetchDistinctUserCount,
  fetchNotLogUserCount,
  fetchTotalNotLogUserCount,
} from "DashboardUserAction";
import { deviceInstallsNew } from "DashboardDeviceAction";
import { fetchNetworkAnalyticsNew } from "DashboardNetworkingAction";
import { fetchSessionAnalytics1 } from "DashboardSessionAction";
import {
  fetchMostSearchKeywordsTableData,
  fetchAttendengagementbBarChart,
} from "DashboardActions"; //
import { dashboardAttendeesCount } from "DashboardAttendeesAction";
import { dashboardAttenadoprateCount } from "DashboardAttenadoprateAction";
import { dashboardAttedengarateRate } from "DashboardAttedengarateAction";
import { dashboardInteractionRate } from "DashboardInteractionAction";
import { dashboardMessagessCount } from "DashboardMessagessAction";

var Loader = require("react-loaders").Loader;
// also available as `default`

class DashboardInside extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      desc: LocaleStrings.analytics_text_preparing_analytics,
      loader: false,
      exportLoading: false,
    };

    this.analyticsDashboard = React.createRef();
  }

  componentDidMount() {
    this.setState({ loading: true });

    // Get Total number of user hits on app
    this.props.fetchTotalNoHits(this.props.session, (callBackResponce) => {
      this.setState({ loading: false });
    });

    // Get Total number of users on app for this Event
    this.props.fetchDistinctUserCount(
      this.props.session,
      (callBackResponce) => {
        this.setState({ loading: false });
      }
    );

    // call to Attendees Engagement (Chart view of how active users have been over the selected date range)
    this.props.fetchAttendengagementbBarChart(
      this.props.session,
      this.props.datePropsMainPg,
      (fetchattendengagementbbarchartResponse) => {
        if (fetchattendengagementbbarchartResponse.error === 0) {
        }
      }
    );

    // Users who login to the app atleast ones [ Attendees ]
    this.props.dashboardAttendeesCount(
      this.props.session,
      (dashboardattendeescountResponse) => {
        if (dashboardattendeescountResponse.error === 0) {
        }
      }
    );

    // Users who login to the app atleast ones [ Attendees ]
    this.props.dashboardAttenadoprateCount(
      this.props.session,
      (dashboardattenadopratecountResponse) => {
        if (dashboardattenadopratecountResponse.error === 0) {
        }
      }
    );

    // Attendees who were engaged in the app from overall attendees [ Attendees Engagement rate ]
    this.props.dashboardAttedengarateRate(
      this.props.session,
      (dashboardattedengaraterateResponse) => {
        if (dashboardattedengaraterateResponse.error === 0) {
        }
      }
    );

    // Number of all actions user did on the app) [ Interaction rate ]
    this.props.dashboardInteractionRate(
      this.props.session,
      (dashboardinteractionrateResponse) => {
        if (dashboardinteractionrateResponse.error === 0) {
        }
      }
    );

    // Total number of messages sent on the app [ Messages count ]
    this.props.dashboardMessagessCount(
      this.props.session,
      (dashboardmessagesscountResponse) => {
        if (dashboardmessagesscountResponse.error === 0) {
        }
      }
    );

    this.setState({ desc: LocaleStrings.analytics_text_preparing_analytics });
    this.props.fetchHits(this.props.session, (userresponse) => {
      if (userresponse.error === 0) {
        this.setState({
          desc: LocaleStrings.analytics_text_plotting_analytics,
        });
        setTimeout(() => {
          this.setState({ desc: LocaleStrings.analytics_text_almost_done });
          setTimeout(() => {
            this.setState({ loading: false });
          }, 1000);
        }, 2000);
      }
    });

    // Call Most search keywords List
    this.props.fetchMostSearchKeywordsTableData(
      this.props.session,
      (fetchMostSearchKeywordsTableDataResponce) => {}
    );

    this.props.deviceInstallsNew(this.props.session, (deviceresponse) => {
      if (deviceresponse.error === 0) {
      }
    });

    this.props.fetchNetworkAnalyticsNew(
      this.props.session,
      (networkingresponse) => {
        if (networkingresponse.error === 0) {
        }
      }
    );

    this.props.fetchSessionAnalytics1(this.props.session, (sessionresponse) => {
      this.setState({ loading: false });
      if (sessionresponse.error === 0) {
      }
    });

    // fetch total no of users who didnt' login yet
    this.props.fetchNotLogUserCount(this.props.session, (res) => {});
    this.props.fetchTotalNotLogUserCount(this.props.session, (res) => {});

    //this.setState({ loading: false });
  }

  renderLoader = () => {
    return (
      <Loader type="line-scale-pulse-out-rapid" active className="loader-div" />
    );
  };

  renderMenuIcons() {
    return _.map(this.props.dashBoardMenu, (menuItem) => {
      return <DashboardMenuIcon menu={menuItem} key={menuItem.key} />;
    });
  }

  // Send function with props for chartdate change
  onDateChartChangeFc(obj) {
    this.setState({ loader: !this.state.loader });
  }

  // Rerender All componets on this page
  mainCallback = () => {
    this.setState({ loading: true });

    // Get Total number of user hits on app
    this.props.fetchTotalNoHits(this.props.session, (callBackResponce) => {});

    // Get Total number of users
    this.props.fetchDistinctUserCount(
      this.props.session,
      (callBackResponce) => {}
    );

    // call to Attendees Engagement (Chart view of how active users have been over the selected date range)
    this.props.fetchAttendengagementbBarChart(
      this.props.session,
      this.props.datePropsMainPg,
      (fetchattendengagementbbarchartResponse) => {
        if (fetchattendengagementbbarchartResponse.error === 0) {
          this.setState({ loading: false });
        }
      }
    );

    // Users who login to the app atleast ones [ Attendees ]
    this.props.dashboardAttendeesCount(
      this.props.session,
      (dashboardattendeescountResponse) => {
        if (dashboardattendeescountResponse.error === 0) {
        }
      }
    );

    // Users who login to the app atleast ones [ Attendees ]
    this.props.dashboardAttenadoprateCount(
      this.props.session,
      (dashboardattenadopratecountResponse) => {
        if (dashboardattenadopratecountResponse.error === 0) {
        }
      }
    );

    // Attendees who were engaged in the app from overall attendees [ Attendees Engagement rate ]
    this.props.dashboardAttedengarateRate(
      this.props.session,
      (dashboardattedengaraterateResponse) => {
        if (dashboardattedengaraterateResponse.error === 0) {
        }
      }
    );

    // Number of all actions user did on the app) [ Interaction rate ]
    this.props.dashboardInteractionRate(
      this.props.session,
      (dashboardinteractionrateResponse) => {
        if (dashboardinteractionrateResponse.error === 0) {
        }
      }
    );

    // Total number of messages sent on the app [ Messages count ]
    this.props.dashboardMessagessCount(
      this.props.session,
      (dashboardmessagesscountResponse) => {
        if (dashboardmessagesscountResponse.error === 0) {
        }
      }
    );

    // fetch total no of users who didnt' login yet
    this.props.fetchNotLogUserCount(this.props.session, (res) => {});

    this.setState({ desc: LocaleStrings.analytics_text_preparing_analytics });
    this.props.fetchHits(this.props.session, (userresponse) => {
      if (userresponse.error === 0) {
        this.setState({
          desc: LocaleStrings.analytics_text_plotting_analytics,
        });
        setTimeout(() => {
          this.setState({ desc: LocaleStrings.analytics_text_almost_done });
          setTimeout(() => {
            this.setState({ loading: false });
          }, 1000);
        }, 2000);
      }
    });

    // Call Most search keywords List
    this.props.fetchMostSearchKeywordsTableData(
      this.props.session,
      (fetchMostSearchKeywordsTableDataResponce) => {}
    );

    this.props.deviceInstallsNew(this.props.session, (deviceresponse) => {
      if (deviceresponse.error === 0) {
        // this.setState({loading:false});
      }
    });

    this.props.fetchNetworkAnalyticsNew(
      this.props.session,
      (networkingresponse) => {
        if (networkingresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    this.props.fetchSessionAnalytics1(this.props.session, (sessionresponse) => {
      this.setState({ loading: false });
      if (sessionresponse.error === 0) {
      }
    });
  };

  exportPdf = () => {
    document.getElementById("analyticsDashboard").style.height = "100%";
    this.setState({ exportLoading: true });

    html2canvas(this.analyticsDashboard.current, {
      logging: true,
      letterRendering: 1,
      useCORS: true,
      scrollY: -window.scrollY,
      scale: 1,
    }).then((canvas) => {
      const imgData = canvas.toDataURL("img/png");

      let imgWidth = 208;
      let imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      const doc = new jsPDF("p", "mm", "a4");
      let pageHeight = doc.internal.pageSize.height;
      doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);

      heightLeft -= pageHeight;
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      document.getElementById("analyticsDashboard").style.height = `${
        this.props.deviceSize.height - screenHeightLeftFromTop
      }px`;
      this.setState({ exportLoading: false });

      doc.save("analytics.pdf");
      // window.open(
      //   doc.output("bloburl", { filename: "analytics.pdf" }),
      //   "_blank"
      // );
    });
  };

  render() {
    let { deviceSize } = this.props;

    // var activeComponent = <DashboardUser users={this.props.users} />;
    var activeComponent = "";
    switch (this.props.dashboardSelectedItem) {
      // case DASHBOARD_USERS:
      //   activeComponent = <DashboardUser users={this.props.users} />;
      //   break;
      case DASHBOARD_DEVICE:
        activeComponent = (
          <DashboardDevice
            devices={this.props.devices}
            newprop={this.state.loader}
          />
        );
        break;
      /*case DASHBOARD_OUTREACH:
          activeComponent = <DashboardOutreach />;
          break;*/
      case DASHBOARD_NETWORKING:
        activeComponent = (
          <DashboardNetworking
            networkings={this.props.networkings}
            newprop={this.state.loader}
          />
        );
        break;
      case DASHBOARD_SESSIONS:
        activeComponent = <DashboardSession sessions={this.props.sessions} />;
        break;
    }

    return (
      <>
        <div className="panel noborder-panel">
          {/* Header section */}
          {!this.state.loading ? (
            <AnalyticsCommonHeader
              finishOperationsCallback={this.mainCallback}
              callFrom="Dashboard"
              xchart={this.onDateChartChangeFc.bind(this)}
              exportData={this.exportPdf}
              loading={this.state.exportLoading}
            />
          ) : (
            ""
          )}

          <div
            className="panel-body scrollable-content"
            style={{
              height: deviceSize.height - screenHeightLeftFromTop,
            }}
            ref={this.analyticsDashboard}
            id="analyticsDashboard"
          >
            {this.state.loading ? (
              <div className="loader-container">
                {this.renderLoader()}
                <div className="loader-info">{this.state.desc}</div>
              </div>
            ) : (
              <div>
                <ul className="nav nav-pills dashboardNavPill">
                  {this.renderMenuIcons()}
                </ul>
                <div className="panel-body mt-20">{activeComponent}</div>
                <div className="panel-body mt-20">
                  {/* <TableContentTopSearch /> */}
                  {this.props.attndsbarchart ? (
                    <DashboardEngmntBarChart
                      attndsbarchart={this.props.attndsbarchart}
                      newprop={this.state.loader}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <UserListModal />
      </>
    );
  }
}

function mapStateToProps(state) {
  var { session, user, dashBoardMenu, dashboardSelectedItem } = state;
  // debugger;
  var users = state.dashboardTotalUsers
    ? state.dashboardTotalUsers.response
    : [];
  var devices = state.dashboardTotalDevices
    ? state.dashboardTotalDevices.response
    : [];
  var sessions = state.dashboardTotalSessions
    ? state.dashboardTotalSessions.response
    : [];
  var networkings = state.dashboardTotalNetworking
    ? state.dashboardTotalNetworking.response
    : [];
  var mostsearchkeys = state.dashboardMostsearchKeysTablelist
    ? state.dashboardMostsearchKeysTablelist
    : [];
  var totalattendees = state.dashboardTotalAttendees
    ? state.dashboardTotalAttendees
    : [];
  var totalattenadoprate = state.dashboardTotalAttenadoprate
    ? state.dashboardTotalAttenadoprate
    : [];
  var totalattedengarate = state.dashboardTotalAttedengaRate
    ? state.dashboardTotalAttedengaRate
    : [];
  var totalinteractionrate = state.dashboardTotalInteractionRate
    ? state.dashboardTotalInteractionRate
    : [];
  var totalmessagesscnt = state.dashboardTotalMessagessCount
    ? state.dashboardTotalMessagessCount
    : [];
  var attndsbarchart = state.dashboardEngagementbarChart
    ? state.dashboardEngagementbarChart.response
    : [];
  var datePropsMainPg = state.analyticscommondatepropsreducer;
  //
  return {
    session,
    user,
    dashBoardMenu,
    dashboardSelectedItem,
    users,
    devices,
    sessions,
    networkings,
    deviceSize: state.deviceSize,
    mostsearchkeys,
    totalattendees,
    totalattenadoprate,
    totalattedengarate,
    totalinteractionrate,
    totalmessagesscnt,
    datePropsMainPg,
    attndsbarchart,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchTotalNoHits,
    fetchDistinctUserCount,
    fetchHits,
    deviceInstallsNew,
    fetchNetworkAnalyticsNew,
    fetchMostSearchKeywordsTableData,
    dashboardAttendeesCount,
    dashboardAttenadoprateCount,
    dashboardAttedengarateRate,
    dashboardInteractionRate,
    dashboardMessagessCount,
    fetchAttendengagementbBarChart,
    fetchSessionAnalytics1,
    fetchNotLogUserCount,
    fetchTotalNotLogUserCount,
  },
  null,
  { forwardRef: true }
)(DashboardInside);
